import {useEffect, useRef, useState} from 'react';
import io from 'socket.io-client';
import axios from 'axios';

const NEW_CHAT_MESSAGE_EVENT = 'newChatMessage';
const SOCKET_SERVER_URL = 'https://arianaapp.iran.liara.run';

const useChat = roomId => {
  const [messages, setMessages] = useState([]);
  const [user, setUser] = useState([]);
  const [messagesState, setMessagesState] = useState(0);

  const socketRef = useRef();

  useEffect(() => {
    const getUser = () => {
      axios
        .get(`https://arianaapp.iran.liara.run/api/V1/get-user/${localStorage.getItem("token")}`)
        .then((response) => {
         
          setUser(response.data);
        });
    }
    getUser();
  }, []);


  useEffect(() => {
    const getMessages = async () => {
      const res = await axios.get(
        `https://arianaapp.iran.liara.run/api/V1/chat/show-message/${roomId}`,
      );
      try {
        if (res.data.length > 0) {
          setMessages(res.data);
          setMessagesState(1);
        } else {
          setMessagesState(2);
        }
      } catch (err) {
        console.log(err.response);
      }
    };
    getMessages();
  }, []);

  useEffect(() => {
    socketRef.current = io(SOCKET_SERVER_URL, {
      query: {roomId},
    });
    console.log(SOCKET_SERVER_URL);

    socketRef.current.on(NEW_CHAT_MESSAGE_EVENT, message => {
      const incomingMessage = {
        ...message,
      };
      setMessages(messages => [...messages, incomingMessage]);
      setMessagesState(1);
    });

    return () => {
      socketRef.current.disconnect();
    };
  }, [roomId]);

  const sendMessage = messageBody => {
    socketRef.current.emit(NEW_CHAT_MESSAGE_EVENT, {
      message: messageBody,
      senderId: socketRef.current.id,
      created_at: Date.now(),
      user_id: [user._id],
    });
  };

  return {messages, sendMessage , messagesState};
};

export default useChat;
